import React from 'react'
import { useLocation, useNavigate } from 'react-router'
import { SectionName } from '_gql'

import { FormattedMessage } from '@divvy-web/i18n'
import { NavigationLink } from '@divvy-web/skylab.mainnavigation'

import ApplicationProgress from '@sputnik/pages/CreditApplicationPages/Navigation/ApplicationProgress'
import { useApplicationProgress } from '@sputnik/pages/CreditApplicationPages/Navigation/useApplicationProgress'
import { PATHNAME_CONSTS } from '@sputnik/resources/constants'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

const ReviewAndSignNavSection = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { track } = useWebTracking()

  const completionStatus = useApplicationProgress({ sectionName: SectionName.REVIEW_AND_SIGN_INFO })

  const isReviewAndSignActive = pathname.includes(PATHNAME_CONSTS.REVIEW_PATH)

  return (
    <NavigationLink
      dataTestId='review-and-sign-navigation-link'
      icon={<ApplicationProgress status={completionStatus} />}
      isActive={isReviewAndSignActive}
      isExact={isReviewAndSignActive}
      label={
        <FormattedMessage
          defaultMessage='Final review'
          id='sputnik.ReviewNavSection__Csk9Zg'
        />
      }
      onClick={() => {
        track('se_signup__left_nav_menu_section_change__fired', {
          navigated_to_page: PATHNAME_CONSTS.REVIEW_PATH,
        })
        navigate({ pathname: PATHNAME_CONSTS.REVIEW_PATH }, { replace: true })
      }}
    />
  )
}

export default ReviewAndSignNavSection
